var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-list-section__wrapper"},[_c('div',{staticClass:"info-list-section"},[_vm._t("before"),(_vm.columns)?_c('v-row',_vm._l((_vm.sections),function(ref,i){
var label = ref.label;
var items = ref.items;
return _c('v-col',{key:i,attrs:{"sm":"12","lg":"6"}},[_c('info-list',{attrs:{"items":items,"label":label}})],1)}),1):_vm._l((_vm.sections),function(ref,i){
var label = ref.label;
var items = ref.items;
return _c('div',{key:i,staticClass:"d-flex flex-row"},[_c('info-list',{attrs:{"items":items,"label":label}})],1)}),_vm._t("after")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }